import { useEffect, useState } from 'react';
import { PLAYHUB_URL } from '../games/nganya/config/gameConfig';
import type { RunResult } from '../games/nganya/types';
import styles from './GameOver.module.css';

interface Props {
  result: RunResult;
  onAgain: () => void;
  onMenu: () => void;
}

export function GameOver({ result, onAgain, onMenu }: Props) {
  const [shown, setShown] = useState(0);

  useEffect(() => {
    setShown(0);
    const start = performance.now();
    let raf = 0;
    const tick = (now: number) => {
      const t = Math.min(1, (now - start) / 900);
      setShown(Math.round(result.score * (1 - Math.pow(1 - t, 3))));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [result.score]);

  const share = async () => {
    const text = `I scored ${result.score} in Nganya on PlayHub! Distance ${result.distance}m · Fares ${result.fares}.`;
    const url = import.meta.env.VITE_PLAYHUB_URL || PLAYHUB_URL;
    try {
      if (navigator.share) {
        await navigator.share({ title: 'Nganya', text, url });
        return;
      }
    } catch {
      // fall through
    }
    try {
      await navigator.clipboard.writeText(`${text} ${url}`);
      alert('Score copied to clipboard');
    } catch {
      alert(text);
    }
  };

  return (
    <div className={`overlay ${styles.wrap}`}>
      <div className={`panel stack ${styles.card}`}>
        <h2 className="title" style={{ fontSize: '1.7rem', textAlign: 'center' }}>
          Run Over
        </h2>
        <div className={styles.score}>{shown}</div>
        <p className="muted" style={{ textAlign: 'center', margin: 0 }}>
          Best {result.bestScore}
        </p>

        <div className={styles.grid}>
          <div>
            <span>Distance</span>
            <strong>{result.distance}m</strong>
          </div>
          <div>
            <span>Fares</span>
            <strong>{result.fares}</strong>
          </div>
          <div>
            <span>Near misses</span>
            <strong>{result.nearMisses}</strong>
          </div>
          <div>
            <span>Crashes</span>
            <strong>
              {result.crashes}/{3}
            </strong>
          </div>
        </div>

        {result.missionComplete && <p className={styles.mission}>Mission bonus unlocked!</p>}
        {result.newAchievements.length > 0 && (
          <p className={styles.ach}>
            Achievements: {result.newAchievements.join(', ')}
          </p>
        )}

        <button type="button" className="btn btn-primary" onClick={onAgain}>
          Play Again
        </button>
        <button type="button" className="btn btn-ghost" onClick={share}>
          Share Score
        </button>
        <button type="button" className="btn btn-ghost" onClick={onMenu}>
          Return to Menu
        </button>
      </div>
    </div>
  );
}
